import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { StingrayCommonModule } from '@modules/common/common.module';
import { LoginSharedModule } from '@modules/login-shared/login-shared.module';
import { LoginAccountLockoutComponent } from '@modules/login/components/login-account-lockout/login-account-lockout.component';
import { LoginClientLogoComponent } from '@modules/login/components/login-client-logo/login-client-logo.component';
import { LoginEnterMFACodeComponent } from '@modules/login/components/login-enter-mfa-code/login-enter-mfa-code.component';
import { LoginFooterHelpComponent } from '@modules/login/components/login-footer-help/login-footer-help.component';
import { LoginFooterComponent } from '@modules/login/components/login-footer/login-footer.component';
import { LoginLayoutMainImgComponent } from '@modules/login/components/login-layout-main-img/login-layout-main-img.component';
import { LoginLayoutMainTextComponent } from '@modules/login/components/login-layout-main-text/login-layout-main-text.component';
import { LoginLayoutMainComponent } from '@modules/login/components/login-layout-main/login-layout-main.component';
import { LoginMainComponent } from '@modules/login/components/login-main/login-main.component';
import { LoginSelectMFAMethodComponent } from '@modules/login/components/login-select-mfa-method/login-select-mfa-method.component';
import { LoginThemingComponent } from '@modules/login/components/login-theming/login-theming.component';
import { LOGIN_ROUTES } from '@modules/login/login.routes';

@NgModule({
    declarations: [
        LoginMainComponent,
        LoginAccountLockoutComponent,
        LoginSelectMFAMethodComponent,
        LoginEnterMFACodeComponent,
        LoginLayoutMainTextComponent,
        LoginLayoutMainImgComponent,
        LoginLayoutMainComponent,
        LoginFooterComponent,
        LoginFooterHelpComponent,
        LoginClientLogoComponent,
        LoginThemingComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        //Start Angular Material
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatSelectModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatIconModule,
        //End Angular Material
        StingrayCommonModule,
        RouterModule.forChild(LOGIN_ROUTES),
        LoginSharedModule
    ]
})
export class LoginModule {
}
